import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import OBSView from './components/OBSView';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Modo overlay para OBS: visor de solo lectura, aislado del resto de la app
// (sin cabecera, sidebar, footer ni proveedores) y con fondo transparente.
const esOverlay = window.location.pathname.replace(/\/+$/, '').endsWith('/quiz/obs-view');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {esOverlay ? <OBSView /> : <App />}
  </React.StrictMode>
);

serviceWorkerRegistration.register();
